
<mat-toolbar color="accent">
	<mat-toolbar-row>
		<span>
			Select a User
		</span>
		<span class="spacer"></span>
		<button mat-raised-button type="button" aria-label="Edit" (click)="handleBack()">
			<mat-icon>chevron_left</mat-icon>
		</button>
		<button type="button" aria-label="Go Back" mat-raised-button (click)="handleUserAdd()">
			<mat-icon>add</mat-icon>
		</button>
		<button mat-raised-button type="button" aria-label="Edit">
			<mat-select [(value)]="isActiveStatus" (selectionChange)="onChangeActiveStatus( $event )" style="width: 80px; text-align: left;">
				<mat-option *ngFor="let element of isActiveStatusList" [value]="element.key">{{ element.value }}</mat-option>
			</mat-select>
		</button>
	</mat-toolbar-row>
</mat-toolbar>

<div class="content-header">
	<form>
		<mat-form-field appearance="standard" tabindex="0">
			<input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
		</mat-form-field>
	</form>
</div>

<table mat-table 
	matSortDirection="asc" 
	matSortActive="user_name" 
	[dataSource]="users" matSort 
	[trackBy]="trackByUserId"
	class="mat-elevation-z8">

	<ng-container matColumnDef="edit">
		<th mat-header-cell class="mat-header-text" *matHeaderCellDef>Edit</th>
		<td mat-cell class="mat-cell-button" *matCellDef="let element">
			<button mat-mini-fab color="white" aria-label="Example icon button with a menu icon"
				(click)="handleRowEdit( element )">
				<mat-icon>visibility</mat-icon>
			</button>
		</td>
	</ng-container>

	<ng-container matColumnDef="username">
		<th mat-header-cell class="mat-cell-name" *matHeaderCellDef mat-sort-header>Username</th>
		<td mat-cell class="mat-cell-name" *matCellDef="let element"> 
			{{ element['username'] }}
		</td>
	</ng-container>

	<ng-container matColumnDef="full_name">
		<th mat-header-cell class="mat-cell-name" *matHeaderCellDef mat-sort-header>Name</th>
		<td mat-cell class="mat-cell-name" *matCellDef="let element"> 
			{{ (element['title'] ? element['title'] + '&nbsp;' : '') + element['last_name'] + ', ' + element['first_name'] }}
		</td>
	</ng-container>

	<ng-container matColumnDef="phone">
		<th mat-header-cell class="mat-cell-name" *matHeaderCellDef mat-sort-header>Phone</th>
		<td mat-cell class="mat-cell-name" *matCellDef="let element"> 
			{{ element['phone'] }}
		</td>
	</ng-container>

	<ng-container matColumnDef="email">
		<th mat-header-cell class="mat-cell-name" *matHeaderCellDef mat-sort-header>Email</th>
		<td mat-cell class="mat-cell-name" *matCellDef="let element"> 
			{{ element['email'] }}
		</td>
	</ng-container>

	<ng-container matColumnDef="roles">
		<th mat-header-cell class="mat-header-text" *matHeaderCellDef mat-sort-header>Role</th>
		<td mat-cell class="mat-cell-text" *matCellDef="let element"> 
			<span class="role-container" *ngFor="let role of element['roles']">
				{{ role.role_name }}
			</span>  
		</td>
	</ng-container>

	<ng-container matColumnDef="visits">
		<th mat-header-cell class="mat-header-text" *matHeaderCellDef mat-sort-header>#Visits</th>
		<td mat-cell class="mat-cell-visits" *matCellDef="let element"> 
			<ng-container *ngIf="element.visits">
				{{ element.visits.length }}
			</ng-container>
		</td>
	</ng-container>

	<ng-container matColumnDef="is_active">
		<th mat-header-cell class="mat-header-text" *matHeaderCellDef mat-sort-header>Active</th>
		<td mat-cell class="mat-cell-visits" *matCellDef="let element"> 
			<ng-container>
				<span [ngStyle]="{ color: element.is_active ? 'green' : 'red' }">
					{{ element.is_active ? 'Yes' : 'No' }}
				</span>
			</ng-container>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
	<tr mat-row *matRowDef="let element; columns: columnsToDisplay;"></tr>
</table>